export default {
  section: 'Depósitos',
  loading: 'Cargando depósitos...',
  headers: {
    date: 'Fecha de emisión',
    id: 'ID',
    status: 'Estatus',
    amount: 'Monto',
    invoice: 'Factura del depósito'
  },
  detail: {
    headers: {
      order: 'Número de orden',
      restaurant: 'Restaurante',
      date: 'Fecha de emisión',
      netTotal: 'Total sin impuestos',
      total: 'Total de la orden',
      invoiceTotal: 'Total de la factura',
      status: 'Estatus',
      invoice: 'Factura',
      folio: 'Folio',
      createdAt: 'Fecha de emisión de la orden',
      subtotal: 'Subtotal',
      taxes: 'Impuestos'
    }
  }
}
